export { default } from "./Panel";
